import { stripeApi } from '../firebase/functionsService';

export const PENDING_APPROVAL_MESSAGE = 'Bestiller må godkjenne før oppdraget er ditt. Du får varsel så snart det er avgjort.';

// «Godta fastpris» på et oppdrag med automatisk godkjenning (førstemann til mølla).
// Resultat: { status: 'matched' } når oppdraget er sjåførens,
//           { status: 'pending', message } når bestiller må godkjenne (f.eks. sjåfør ikke verifisert),
//           { status: 'error', message, canRetry } ved feil. Kaster aldri.
export async function takeOrder(orderId) {
  try {
    const res = await stripeApi.takeOrder(orderId);
    if (res?.status === 'matched') return { status: 'matched' };
    return { status: 'pending', message: PENDING_APPROVAL_MESSAGE };
  } catch (err) {
    const code = err?.code;
    const isClearError = typeof code === 'string' && code.startsWith('functions/')
      && code !== 'functions/internal' && code !== 'functions/unknown';
    return {
      status: 'error',
      canRetry: !isClearError,
      message: isClearError ? err.message : 'Kunne ikke ta oppdraget. Prøv igjen.',
    };
  }
}
